import { readStorage, removeStorage } from '@/utils/storage/base'
import { envConfig } from '@/shared/config/env'

const getLogtoAppId = () => envConfig.logtoAppId

const buildLogtoKey = (suffix: 'refreshToken' | 'accessToken' | 'idToken') => {
  const appId = getLogtoAppId()
  if (!appId) return null
  return `logto:${appId}:${suffix}`
}

export const logtoStorage = {
  getRefreshToken: () => {
    const key = buildLogtoKey('refreshToken')
    return key ? readStorage(key, null) : null
  },
  getIdToken: () => {
    const key = buildLogtoKey('idToken')
    return key ? readStorage(key, null) : null
  },
  getAccessTokenStorageKey: () => buildLogtoKey('accessToken'),
  getAccessTokenCacheRaw: () => {
    const key = buildLogtoKey('accessToken')
    return key ? readStorage(key, null) : null
  },
  clearAccessTokenCache: () => {
    const key = buildLogtoKey('accessToken')
    if (key) removeStorage(key)
  },
  clearPersistedSession: () => {
    const refreshTokenKey = buildLogtoKey('refreshToken')
    const idTokenKey = buildLogtoKey('idToken')
    const accessTokenKey = buildLogtoKey('accessToken')
    if (refreshTokenKey) removeStorage(refreshTokenKey)
    if (idTokenKey) removeStorage(idTokenKey)
    if (accessTokenKey) removeStorage(accessTokenKey)
  },
  hasPersistedSession: () =>
    Boolean(logtoStorage.getRefreshToken() || logtoStorage.getIdToken() || logtoStorage.getAccessTokenCacheRaw()),
}
